import React from 'react';
import PropTypes from 'prop-types';
import styles from './SidebarActions.module.scss';
import { noop } from 'lodash-es';

export const SidebarActions = (props) => {
  return <div className={styles.actionsContainer}>{props.children}</div>;
};

SidebarActions.propTypes = {
  children: PropTypes.any,
};

export const ActionButton = (props) => {
  const Icon = props.icon || React.Fragment;

  return (
    <div className={styles.actionButton} onClick={props.onClick}>
      <div
        className={[styles.actionIcon, props.active ? styles.active : ''].join(
          ' '
        )}
      >
        <Icon width={20} height={20} color={'#fff'} />
      </div>
      <span className={styles.actionName}>{props.children}</span>
    </div>
  );
};

ActionButton.defaultProps = {
  onClick: noop,
};

ActionButton.propTypes = {
  children: PropTypes.any,
  icon: PropTypes.any,
  active: PropTypes.bool,
  onClick: PropTypes.func,
};
